<template>
  <div>
    <div class="contain">
      <img class="imgs" src="../../../assets/c40/image13.png" ref="secondImage" />
      <img class="imgs" src="../../../assets/c40/image14.png" />
      <img class="imgs" src="../../../assets/c40/image15.png" />
      <img class="imgs" src="../../../assets/c40/image16.png" />
      <img class="imgs" src="../../../assets/c40/image17.png" />
      <img class="imgs" src="../../../assets/c40/image18.png" />
      <img class="imgs" src="../../../assets/c40/image19.png" />

      <!-- cta button -->
      <div :class="['full-bottom-float-cta', { scrolled: isScrolled}]">
        <a @click="selfDeepLink" class="pointer">
            쿠폰 사용하러 가기
        </a>
      </div>

    </div>
  </div>
</template>

<script>
// import SlotCountdownTimer from "../../common/SlotCountdownTimer.vue";
// import CustomModal from "../../common/CustomModal.vue";

export default {
  name: 'c39',
  components: {
    // SlotCountdownTimer,
    // CustomModal
  },
  data: function () {
    return {
      isScrolled: false,
      abx_tid: null,
      isInApp: false,
      ctaLink: 'https://official.soldoc.co.kr/api/v1/click/SePl7OkxD0G2YrVjHdowIQ?adv_campaign=barosoldoc&adv_ad=monimo&adv_adgroup=promotion&adv_creative=%EB%AA%A8%EB%8B%88%EB%AA%A8%EC%9D%B4%EB%B2%A4%ED%8A%B8_cta_2505221&abx_tracker_id=SePl7OkxD0G2YrVjHdowIQ',
      showToast: false,
    }
  },
  methods: {
    copyCoupon(couponCode) {
      // navigator.clipboard.writeText(couponCode)
      //   .then(() => {
      //     this.showToast = true;
      //     setTimeout(() => {
      //       this.showToast = false;
      //     }, 2500);
      //   })
      //   .catch(err => {
      //     console.error('Failed to copy: ', err);
      //   });
      try {
        // 대체 복사 방법: 임시 textarea 요소 사용
        const textarea = document.createElement('textarea');
        textarea.value = couponCode;
        textarea.style.position = 'fixed';  // 화면 밖으로 위치시킴
        textarea.style.left = '-9999px';
        textarea.style.top = '-9999px';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        const successful = document.execCommand('copy');
        document.body.removeChild(textarea);

        if (successful) {
          // 토스트 메시지 표시
          this.showToast = true;

          // 3초 후 토스트 메시지 숨기기
          setTimeout(() => {
            this.showToast = false;
          }, 3000);
        } else {
          console.error('쿠폰번호 복사 실패');
        }
      } catch (err) {
        console.error('쿠폰번호 복사 실패:', err);
      }
    },
    deepLink: function () {
      window.location.href = 'soldoc://home/search?departmentId=26?serviceType=CONTACTLESS?type=DEPARTMENT?after-login';
    },
    selfDeepLink() {
      if (this.isInApp) {
        this.deepLink();
        return;
      }

      // 고정 링크가 존재한다면 리다이렉션 후킹
      if (this.ctaLink) {
        window.location.href = this.ctaLink;
        return;
      }

      if (!navigator.userAgent.match(/Android/i) && !navigator.userAgent.match(/iPhone|iPad/i)) {
        window.location.href = 'https://event.soldoc.co.kr/';
        return;
      }

      if (!wcs_add) var wcs_add = {};
      window.wcs_add = {wa: "s_4b46bc66587"}; //윈도우 객체 선언
      if (!_nasa) var _nasa = {};
      if (window.wcs) {
        wcs.inflow();
        wcs_do();
      }
      if (window.wcs) {
        if (!wcs_add) var wcs_add = {};
        window.wcs_add = {wa: "s_4b46bc66587"}; //윈도우 객체 선언
        var _conv = {};
        _conv.type = 'lead';
        wcs.trans(_conv);
      }

      // 앱의 스키마 URL
      var appSchemeURL = 'soldoc://home/search?departmentId=26?serviceType=CONTACTLESS?type=DEPARTMENT?after-login';
      // 안드로이드와 iOS 마켓 URL
      var androidMarketURL = 'https://play.google.com/store/apps/details?id=com.soldocapp';
      var iosMarketURL = 'https://apps.apple.com/kr/app/soldoc-%EB%B9%84%EB%8C%80%EB%A9%B4%EC%A7%84%EB%A3%8C-%EC%86%8C%EB%B9%84%EC%9E%90%EB%A7%8C%EC%A1%B1%EC%A7%80%EC%88%98-1%EC%9C%84/id1667730511';

      if (this.abx_tid !== undefined) {
        appSchemeURL += `&abx_tid=${this.abx_tid}`;
        // Google Play 스토어 링크
        androidMarketURL += `&referrer=abx_tid%3D${this.abx_tid}`;
        //appstore 스토어 링크
        iosMarketURL += `?&referrer=abx_tid%3D${this.abx_tid}`;
      }

      // 리다이렉트를 체크할 시간 간격
      var timeoutMs = 2000;

      // 앱 실행 시도
      window.location.href = appSchemeURL;

      // 2초 후에 페이지 가시성 체크
      setTimeout(function () {
        if (document.visibilityState === 'visible') {
          // 사용자의 기기에 따라 적절한 마켓으로 리다이렉트
          if (navigator.userAgent.match(/Android/i)) {
            window.location.href = androidMarketURL;
          } else if (navigator.userAgent.match(/iPhone|iPad/i)) {
            window.location.href = iosMarketURL;
          } else {
            window.location.href = 'https://event.soldoc.co.kr/';
          }
        }
      }, timeoutMs);
    },
    handleScroll() {
      const secondImage = this.$refs.secondImage;
      const rect = secondImage.getBoundingClientRect();
      this.isScrolled = rect.top <= window.innerHeight - 1600;
    },
  },
  mounted() {
    this.isInApp = this.$route.query.inapp;
    if (this.isInApp === null || this.isInApp === undefined || this.isInApp !== 'true') {
      this.isInApp = false;
    } else {
      this.isInApp = true;
    }

    function getAbxTidParameter() {
      const params = new URLSearchParams(window.location.search);
      return params.get('abx_tid') || true;
    }

    this.abx_tid = getAbxTidParameter();

    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
}
</script>

<style scoped>
  .pointer {
    cursor: pointer;
  }

  .contain {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    min-width: 800px;
  }

  .contain > img:nth-child(2),
  .contain > img:nth-child(3) {
    margin-top: -1px;
  }

  /*
  .contain > img:not(:last-child) {
    display:block;
    margin-top:-1px;
  }
  */

  .contain .sr-only {
    position: absolute;
    left: -9999px;
    width: 1px;
    height: 1px;
    margin: 0 !important;
    font-size: 0;
    line-height: 0;
    overflow: hidden;
  }

  .bottom-float-cta {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 35px;
    width: 712px;
    height: 90px;

    visibility: hidden;
    opacity: 0;
    transition: 0.3s ease;
    z-index: 50;
    border-radius: 0.7rem;
    background-color:#000;
    box-shadow: 0 0.237rem 0.948rem 0 rgba(0, 0, 0, 0.10);
  }

  .bottom-float-cta a {
    display:flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    font-size: 32px;
    font-weight: 600;
    color: #fff;
    text-decoration: none;
  }

  .bottom-float-cta.scrolled {
    visibility: visible;
    opacity: 1;
  }

  .full-bottom-float-cta {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left:0;
    transform: translate(0, 0);
    width: 800px;
    min-width: 800px;
    padding:35px 44px;

    visibility: hidden;
    opacity: 0;
    transition: 0.3s ease;
    z-index: 50;
    border-radius: 0.7rem 0.7rem 0 0;
    background-color:#fff;
    box-shadow: 0 0.237rem 0.948rem 0 rgba(0, 0, 0, 0.10);
  }

  .full-bottom-float-cta.scrolled {
    visibility: visible;
    opacity: 1;
  }

  .full-bottom-float-cta a {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    padding:29px 0;

    font-size: 32px;
    font-weight: 600;
    color: #fff;
    text-decoration: none;
    background: #0068FF;
    line-height: 32px;
    border-radius: 12px;
  }

  .full-bottom-float-cta a:hover,
  .full-bottom-float-cta a:active,
  .full-bottom-float-cta a:focus,
  .full-bottom-float-cta a:not([href]):not([class]),
  .full-bottom-float-cta a:not([href]):not([class]):hover {
    color: #fff;
    text-decoration: none;
  }

  .custom-timer-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 19px;
    margin-bottom: 22px;
  }

  .custom-timer-container .custom-timer-icon {
    display: flex;
    align-items: center;
  }

  .custom-timer-container .custom-timer-icon span {
    display: flex;
    width: 29px;
    height: 29px;
    padding: 0 10px;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    background-color: #0068ff;

    color: #fff;
    font-size: 28px;
    font-weight: 600;
    line-height: 28px;
  }

  .custom-timer-container .custom-timer-icon img {
    width: 29px;
  }

  .custom-timer-container .custom-timer-title {
    color: #000;
    font-family: Pretendard, "Pretendard", sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    text-align: center;
    line-height: 32px; /* 100% */
    letter-spacing: -0.8px;
  }

  .custom-timer-container .custom-timer-title .point {
    color: #0068FF;
  }

  .custom-timer-container .custom-countdown {
    display: flex;
  }

  .custom-timer-container .custom-countdown .custom-time-block {
    display: flex;
  }

  .custom-time-block .time-digits {
    display: flex;
  }

  .custom-time-block .time-digits .digit,
  .custom-time-block .time-digits .separator {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: Pretendard, "Pretendard", sans-serif;
    font-size: 34px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px; /* 100% */
    letter-spacing: -0.68px;
  }

  .custom-time-block .time-digits .digit {
    width: 30px;
    height: 44px;
    padding: 0 4px;
    border-radius: 6px;
    background: #F3F4F4;
    color: #0068FF;
  }

  .custom-time-block .time-digits span:nth-child(3n+1) {
    margin-right:4px;
  }

  .custom-time-block .time-digits .separator {
    color: #333;
  }

  .video-wrap {
    position: relative;
    width: 100%;
    height: 0;
    /* 16:9 비율 */
    padding-bottom: 56.25%;
    overflow: hidden;
  }
  .video-wrap iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  @media screen and (min-width: 800px) {
    .full-bottom-float-cta {
      left:50%;
      transform: translate(-50%, 0);
    }

    .video-wrap {
      width: 800px;
      height: 450px;
      padding-bottom:0;
    }
  }

  /* custom-modal */
  .main-space .info-title {
    color: #0068FF;
  }

  .main-space .box .box-section .box-section-title {
    color: #0068FF;
  }

  .main-space .box .box-section .section-title {
    color: #0068FF;
  }

  .main-space .box.blue {
    background-color: #F5F9FF;
  }

  .toast {
    position: fixed;
    bottom: 120px;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 30px 26px;
    border-radius: 24px;
    font-size: 32px;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s, visibility 0.3s;
    z-index: 1000;
  }

  .show-toast {
    opacity: 1;
    visibility: visible;
  }
</style>



// WEBPACK FOOTER //
// src/components/pc_view/contents/c40.vue